import { DraftState } from '@/types';

export type DraftAction = (draft: DraftState) => void | DraftState;
export type DraftReducer = (draft: DraftState, action: DraftAction) => DraftState;
export type DraftValidator = (draft: DraftState, previousDraft: DraftState) => void;

export interface DraftActionWithMemo extends DraftAction {
  noHistory?: boolean;
}

export enum DraftWarning {
  DPIBound = 'error.dpiBound',
  EqualizedOnAdd = 'error.equalizedOnAdd',
  EqualizedSleevesOnAdd = 'error.equalizedSleevesOnAdd',
  EqualizedOnSwitch = 'error.equalizedOnSwitch',
  EqualizedSleevesOnSwitch = 'error.equalizedSleevesOnSwitch',
  ChangeAllDesignColors = 'error.changeAllDesignColors',
  PrintAreaBound = 'maximumPrintTypeScale.hint',
}
